import React from "react";
import { Modal, Button } from "react-bootstrap";
import { apiDeleteMarque } from "../../../api/ApiMarque";
import { useTranslation } from "react-i18next";

const ModalDelete = (props) => {
  const { t } = useTranslation();
  const { id, show, handleClose, handleRecupDatas } = props;

  const submitData = async () => {
    await apiDeleteMarque(id);
    handleRecupDatas();
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t("admin.PageAdminMarques.modalDeleteTitre")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{t("admin.PageAdminMarques.modalDeleteText")}</Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          {t("commun.form.button.annuler")}
        </Button>
        <Button variant="success" onClick={submitData}>
          {t("commun.form.button.confirmSuppression")}
        </Button>
        <div className="fst-italic mt-2 text-end">
          {t("admin.PageAdminMarques.modalWarningDeleteText")}
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDelete;
